import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Picker from 'react-mobile-picker';
import UserIcon from '../icons/userIcon';
import ChevronIcon from '../icons/chevronIcon';
import { useTranslation } from 'react-i18next';
import {
  formatDateTime,
  formatShortDayName,
  getLocale,
  isTodayDate,
  isTomorrow,
  reservationDetailDateShort,
} from '../../helpers/dates';
import { format } from 'date-fns';
import { setReservation } from '../../actions/reservationActions';
import { useDispatch, useSelector } from 'react-redux';
import './styles.css';
const BookSelectorFixed = ({ children }) => {
  const [portalRoot, setPortalRoot] = useState(null);
  useEffect(() => {
    const element = document.getElementById('bookSelector');
    if (element) {
      setPortalRoot(element);
    }
  }, []);
  if (!portalRoot) {
    return null;
  }

  return createPortal(<div>{children}</div>, portalRoot);
};
const BookSelectorModify = ({ today, lang, onChange, selectedDateBook, paxs }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const reservation = useSelector((state) => state.reservation);
  const [isOpen, setIsOpen] = useState(false);
  const [times, setTimes] = useState([]);
  const locale = getLocale(lang);

  const dates = Array.from({ length: 90 }, (_, i) => {
    const date = new Date(today);
    date.setDate(date.getDate() + i);
    return date;
  });

  const getRemainingTimes = (date) => {
    const timesArray = [];

    let currentTime = new Date(date);

    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);

    while (currentTime <= endOfDay) {
      timesArray.push({
        timeDisplay: currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        timeValue: format(currentTime, 'HH:mm'),
      });
      currentTime = new Date(currentTime.getTime() + 15 * 60000);
    }

    setTimes(timesArray);
  };

  const [pickerValue, setPickerValue] = useState({
    pax: paxs || 2,
    date: selectedDateBook
      ? format(new Date(selectedDateBook), 'yyyy-MM-dd')
      : format(today, 'yyyy-MM-dd'),
    time: format(selectedDateBook, 'HH:mm') || format(today, 'HH:mm'),
  });
  const [pickerSelected, setPickerSelected] = useState(pickerValue);

  useEffect(() => {
    const initialDate = selectedDateBook ? new Date(selectedDateBook) : new Date(today);
    getRemainingTimes(initialDate);
  }, [today, selectedDateBook]);

  const onHandleDone = () => {
    setIsOpen(false);
    setPickerSelected(pickerValue);
    const reservationInfo = {
      ...reservation,
      date: pickerValue.date,
      performance: pickerValue.time,
      paxs: pickerValue.pax,
    };
    dispatch(setReservation(reservationInfo));
    if (onChange) onChange(pickerValue);
  };

  const onHandleChange = (e) => {
    if (e.date === format(today, 'yyyy-MM-dd')) {
      getRemainingTimes(today);
    } else if (e.date !== pickerValue.date) {
      getRemainingTimes(formatDateTime(e.date, '00:00:00'));
    }

    setPickerValue(e);
  };

  return (
    <>
      <div className='book-resume fw-semibold' onClick={() => setIsOpen(true)}>
        <UserIcon size={18} color={'#000'} styles={{ marginTop: '-4px' }} />
        {` ${pickerSelected.pax} • ${reservationDetailDateShort(
          formatDateTime(pickerSelected.date, pickerSelected.time),
          locale,
        )}  ${format(formatDateTime(pickerSelected.date, pickerSelected.time), 'h:mm aaa')}`}

        <ChevronIcon fillColor='#000' rotation={90} />
      </div>
      <BookSelectorFixed>
        <div className={`book-selector font-medium ${isOpen ? 'open' : ''}`}>
          <div className='font-normal text-right py-2 px-3' onClick={() => onHandleDone()}>
            {t('done')}
          </div>

          <Picker value={pickerValue} onChange={onHandleChange}>
            <Picker.Column key={'pax'} name={'pax'}>
              {Array.from({ length: 20 }, (_, i) => (
                <Picker.Item key={i + 1} value={i + 1}>
                  {({ selected }) => (
                    <div
                      className='text-capitalize'
                      style={{ color: selected ? '#fff' : '#7a7676' }}
                    >
                      {t('person', { count: i + 1 })}
                    </div>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
            <Picker.Column key={'date'} name={'date'}>
              {dates.map((item, i) => (
                <Picker.Item key={i} value={format(item, 'yyyy-MM-dd')}>
                  {({ selected }) => (
                    <div style={{ color: selected ? '#fff' : '#7a7676' }}>
                      {isTodayDate(today, item)
                        ? t('today')
                        : isTomorrow(today, item)
                        ? t('tomorrow')
                        : formatShortDayName(item, locale)}
                    </div>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
            <Picker.Column key={'time'} name={'time'}>
              {times.map((time) => (
                <Picker.Item key={time.timeValue} value={time.timeValue}>
                  {({ selected }) => (
                    <div style={{ color: selected ? '#fff' : '#7a7676' }}>{time.timeDisplay}</div>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
          </Picker>
        </div>
      </BookSelectorFixed>
    </>
  );
};
export default BookSelectorModify;
